<template>
  <v-dialog v-model="dialog" max-width="500">
    <template #activator="{ props }">
      <slot name="activator" :props="props"></slot>
    </template>

    <v-card class="onest-font rounded-2xl shadow-lg border">
      <v-card-title
        class="d-flex justify-space-between align-center px-6 py-4 border-b"
      >
        <span class="text-h6 font-bold text-gray-900"
          >Detalhamento de Papéis</span
        >
        <v-btn
          variant="plain"
          rounded="xl"
          icon="mdi-close"
          size="small"
          @click="dialog = false"
        ></v-btn>
      </v-card-title>

      <v-card-text class="pa-6">
        <div class="mb-4 text-sm text-gray-600">
          Abaixo estão listados todos os papéis do convite enviado para
          <strong>{{ usuarioNome }}</strong> e o status de cada um:
        </div>

        <div class="space-y-3">
          <div
            v-for="papel in papeis"
            :key="papel.nomeAtor"
            class="border rounded-xl p-4 bg-gray-50/50 hover:bg-gray-50 transition-colors"
          >
            <div class="d-flex justify-space-between align-center mb-1">
              <span class="font-bold text-gray-800">{{ papel.nomeAtor }}</span>
              <v-chip
                size="small"
                :color="
                  papel.flagAceito
                    ? 'success'
                    : papel.justificativa
                    ? 'error'
                    : 'warning'
                "
                variant="flat"
                class="font-bold text-xs"
              >
                {{
                  papel.flagAceito
                    ? 'Aceito'
                    : papel.justificativa
                    ? 'Recusado'
                    : 'Pendente'
                }}
              </v-chip>
            </div>

            <!-- Detalhes de justificativa/status -->
            <div
              v-if="papel.justificativa"
              class="mt-2 p-3 bg-red-50 text-red-800 rounded-lg text-xs border border-red-100/50"
            >
              <strong class="font-semibold block mb-0.5"
                >Justificativa da Recusa:</strong
              >
              {{ papel.justificativa }}
            </div>
            <div
              v-else-if="papel.flagAceito"
              class="text-xs text-green-700 mt-1.5 flex align-center"
            >
              <v-icon size="14" color="success" class="mr-1"
                >mdi-check-circle</v-icon
              >
              Papel aceito para participar da validação.
            </div>
            <div v-else class="text-xs text-amber-700 mt-1.5 flex align-center">
              <v-icon size="14" color="warning" class="mr-1"
                >mdi-clock-outline</v-icon
              >
              Aguardando retorno do usuário.
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions
        class="px-6 py-4 border-t d-flex justify-end bg-gray-50/50 rounded-b-2xl"
      >
        <v-btn
          color="primary"
          variant="flat"
          class="rounded-xl px-6 font-bold"
          @click="dialog = false"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * @module ModalVisualizarPapeis
 * @description Modal para exibir de forma detalhada e organizada todos os papéis aceitos, recusados (com justificativa) ou pendentes de um convidado.
 *
 * @property {Array} papeis - Array com os papéis e seus status de aceite/recusa.
 * @property {string} usuarioNome - Nome do usuário convidado.
 */
export default {
  name: 'ModalVisualizarPapeis',
  props: {
    papeis: {
      type: Array,
      required: true,
    },
    usuarioNome: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.75rem;
}
</style>
